/**
 * @returns {DocumentFragment}
 */
function buildDialog() {
  const dialogTemplate = `
    <div class="modal fade login-form-dialog" id="login-dialog">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
            <h4 class="modal-title">ログイン</h4>
          </div>
          <div class="modal-body">
            <a class="btn btn-primary btn-block btn-lg" href="/auth/login" data-sso>ヘヤゴトIDでログイン</a>
            <a class="btn btn-default btn-block btn-lg" href="/signup" data-sso>ヘヤゴトIDを作る</a>

            <p class="login-form__confirmation">
              <a href="/terms-of-use" target="_blank">利用規約</a> 及び
              <a href="https://heyagoto.co.jp/privacy.html" target="_blank">プライバシーポリシー</a>
              に同意の上、ログインまたはヘヤゴトIDを作成して下さい。
            </p>

            <div class="login-form__benefit">
              <h4 class="login-form__benefit-title">ヘヤゴトIDでもっと便利に！</h4>
              <p class="login-form__benefit-summary">
                 <b>無料のヘヤゴトID</b>を作るとショップナビをさらに便利にご利用頂けます！
              </p>

              <div class="login-form__benefit-list">
                <div class="login-form__benefit-list-item">
                  <div class="login-form-benefit">
                    <div class="login-form-benefit__title">
                      お店をお気に入りに保存、いつでも見返せる
                    </div>
                    <div class="login-form-benefit__image">
                      <img class="img-responsive" src="/assets/front/images/member-benefit-bookmark.svg" alt="お気に入り機能が利用可能">
                    </div>
                  </div>
                </div>
                <div class="login-form__benefit-list-item">
                  <div class="login-form-benefit">
                    <div class="login-form-benefit__title">
                      全国の家具店へ欲しい商品のお見積りを依頼できる
                    </div>
                    <div class="login-form-benefit__image">
                      <img class="img-responsive" src="/assets/front/images/member-benefit-cunsultation.svg" alt="一括問い合わせサービスが利用可能">
                    </div>
                  </div>
                </div>
                <div class="login-form__benefit-list-item">
                  <div class="login-form-benefit">
                    <div class="login-form-benefit__title">
                      お店へのクチコミ投稿ができる
                    </div>
                    <div class="login-form-benefit__image">
                      <img class="img-responsive" src="/assets/front/images/member-benefit-review.svg" alt="クチコミ投稿が可能">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-default" data-dismiss="modal">あとで行う</button>
          </div>
        </div>
      </div>
    </div>
  `;

  const template = document.createElement('template');
  template.innerHTML = dialogTemplate;

  return template.content.firstElementChild;
}

/**
 * @param {string|null} [destination]
 */
function showLoginForm(destination) {
  const dialog = buildDialog();

  if (!destination) {
    destination = window.location.href;
  }

  dialog.querySelectorAll('a[data-sso]')
    .forEach(a => {
      const [path, qs] = a.href.split('?');
      const params = new URLSearchParams(qs);
      params.append('destination', destination);
      a.href = path + '?' + params.toString();
    });

  document.body.appendChild(dialog);
  $(dialog).modal('show');
}

function initializeLoginDialog() {
  if (JSON.parse(document.querySelector('meta[name="x-customer"]').content) !== null) {
    return;
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.body.addEventListener('click', e => {
      /**
       * @type {HTMLElement}
       */
      let trigger = e.target;

      if (!trigger.matches('[data-auth], [data-auth] *')) {
        return;
      }

      e.preventDefault();

      if (trigger.dataset.auth === undefined) {
        trigger = trigger.closest('[data-auth]');
      }

      const destination = trigger.dataset.auth || trigger.href;
      showLoginForm(destination);
    });
  });

  document.addEventListener('DOMContentLoaded', () => {
    document.body.addEventListener('click', e => {
      /**
       * @type {HTMLElement}
       */
      let trigger = e.target;

      if (!trigger.matches('[data-sso], [data-sso] *')) {
        return;
      }

      const indicator = document.createElement('div');
      indicator.classList.add('loading');
      indicator.innerHTML = '<i class="fa fa-refresh fa-spin"></i>';
      document.body.appendChild(indicator);

      window.addEventListener('unload', () => {
        indicator.remove();
      });
    });
  });
}

initializeLoginDialog();
